import React from "react";
import SectionContainer from "@/components/common/SectionContainer";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_interior_wide.png",
  alt: "Spacious yurt interior with comfortable seating and rustic decor"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_exterior_night.png",
  alt: "Yurt exterior warmly illuminated against the night sky"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_bedroom_setup.png",
  alt: "Cozy bedroom setup inside the yurt with a large bed"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/lake_sunset_vibrant.png",
  alt: "Vibrant orange and purple sunset reflecting over the calm lake"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/trees_fairy_lights.png",
  alt: "Forest trees decorated with enchanting fairy lights at dusk"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/deer_in_forest.png",
  alt: "Wild deer spotted grazing in the surrounding lush forest"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_firepit_day.png",
  alt: "Yurt exterior featuring a stone firepit ready for evening gatherings"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/lake_reflection_dusk.png",
  alt: "Serene lake perfectly reflecting the soft colors of dusk"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/colorful_bird_branch.png",
  alt: "Brightly colored bird perched delicately on a tree branch"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/couple_lake_view.png",
  alt: "Couple standing together enjoying the expansive view of the lake"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_doorway_view.png",
  alt: "Inviting view looking out from the yurt doorway into nature"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/butterfly_on_flower.png",
  alt: "Close up of a beautiful butterfly resting on a vibrant wildflower"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_living_area.png",
  alt: "Comfortable living area inside the yurt with a leather sofa"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/dramatic_sunset_clouds.png",
  alt: "Dramatic cloud formations painted by the setting sun"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/geese_by_water.png",
  alt: "Flock of geese resting peacefully by the water's edge"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/couple_embracing_nature.png",
  alt: "Couple embracing in the tall grass with the lake in the background"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_exterior_landscape.png",
  alt: "Wide landscape view showing the yurt nestled in its natural setting"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/deer_fawn_close.png",
  alt: "Heartwarming close up of a mother deer and her fawn"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/wildflowers_field.png",
  alt: "Expansive field of blooming yellow and purple wildflowers"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/lake_sunset_calm.png",
  alt: "Calm and peaceful sunset casting a golden glow over the water"
}].map(img => ({
  ...img,
  srcset: `${img.src}-wvc-srcset`,
  sizes: `${img.src}-wvc-sizes`
}));
export default function GlampingGallery() {
  return;
}